import styles from './Stat.module.scss'

type Props = {
  label: React.ReactNode
  value: React.ReactNode
}

const Stat = ({ label, value }: Props) => (
  <div className={styles.statContainer}>
    <div className={styles.value}>{value}</div>
    <div className={styles.label}>{label}</div>
  </div>
)

export default Stat
